import axios from 'axios';
import {HttpAxiosBuilder} from "./httpAxiosBuilder";
import {authTokenStorage} from "../utils/localStorage";

let axiosInstanceHeaders: any;
const tokenAutorizacion: string | null = authTokenStorage.get();

/* Los headers usan "common" para que se aplique para todas las request. */
if (tokenAutorizacion != null) {
    axiosInstanceHeaders = {
        common: {'Authorization': "Bearer " + tokenAutorizacion}
    }
}

/* Si se desea configurar para que consuma la api de forma local, dentro de public/configuration.js
   setear en domain localhost:44341 */
const axiosInstance = axios.create({
    baseURL: `${window.API_PROTOCOL}://${window.API_DOMAIN}/api/${window.API_VERSION}/`,
    timeout: window.API_TIMEOUT,
    headers: axiosInstanceHeaders
});

export const HttpAxiosRequest = HttpAxiosBuilder(axiosInstance)